import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TapestryCheckboxModule, GridModule } from '@predictiveindex/tapestry';
import { UserGridComponent } from './user-grid.component';

@NgModule({
    declarations: [UserGridComponent],
    imports: [GridModule, TapestryCheckboxModule, FormsModule, CommonModule],
    exports: [UserGridComponent]
})
export class UserGridModule {}
